import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import HeaderBar from '../components/helpers/HeaderBar.jsx';
import HeaderLinks from '../components/helpers/HeaderLinks.jsx';
import { connect } from 'react-redux';
import { hideSignInDialog } from '../store/actions/signin';
import FlatButton from 'material-ui/FlatButton';
import './Home.css';

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    hideSignInDialog: () => {
      dispatch(hideSignInDialog());
    },
  }
}

class Home extends Component {
  componentDidMount() {
    const {
      hideSignInDialog,
    } = this.props;
    hideSignInDialog();
  }

  goToGenerator() {
    browserHistory.push('/generate');
  }

  render () {
    return (
      <div>
        <HeaderBar rightAction={
            <HeaderLinks auth={this.props.auth} />
          } />
        <div className="page-wrapper">
          <p>
            Thanks for signing in! <b>You are awesome!</b>
          </p>
          <p>
            Unfortunately, this part of our site is not quite ready yet.
          </p>
          <p>
            Check back soon for the ability to save and share your favorite font pairings.
          </p>
          <FlatButton
            label="Back to the generator"
            className="back-to-generator-button"
            backgroundColor="#30353a"
            hoverColor="#686C6F"
            onClick={this.goToGenerator}
          />
        </div>
      </div>
    )
  }
}

export default Home = connect(undefined, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/pages/Home.jsx